import { gql } from '@apollo/client';

export const CoursesQuery = gql`
  query AllCourses(
    $active: Boolean
    $finished: Boolean
    $first: Int
    $after: String
    $last: Int
    $search: String
    $courseId: ID
    $groupIds: [ID]
    $lessonDate: Date
  ) {
    allGroupsForLms(
      active: $active
      finished: $finished
      first: $first
      after: $after
      last: $last
      search: $search
      courseId: $courseId
      groupIds: $groupIds
      lessonDate: $lessonDate
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ... on GroupType {
            id
            course {
              id
              courseIcon
              educationForm
              name
            }
            passedLessonsCount
            lessonsCount
            studentsCount
            name
            statusFinished
            datetimeNextLesson
          }
          ... on StudentGroupType {
            id
            course {
              id
              courseIcon
              educationForm
              name
            }
            passedLessonsCount
            lessonsCount
            studentsCount
            name
            statusFinished
            datetimeNextLesson
          }
          ... on MethodistGroupType {
            id
            course {
              id
              courseIcon
              educationForm
              name
            }
            passedLessonsCount
            lessonsCount
            studentsCount
            name
            statusFinished
            datetimeNextLesson
          }
        }
      }
    }
  }
`;

// Lightweight source for the methodist filter selects: the main AllCourses list is
// paginated by 5, so select options are fetched separately in one shot.
// Operation name intentionally differs from the backend field name (codegen rule).
export const MethodistGroupOptionsQuery = gql`
  query MethodistGroupOptions {
    allGroupsForLms(first: 500) {
      edges {
        node {
          ... on MethodistGroupType {
            id
            name
            course {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const CourseQuery = gql`
  query groupForLms($groupId: ID) {
    groupForLms(groupId: $groupId) {
      ... on GroupType {
        id
        course {
          id
          courseIcon
          name
        }
        statusFinished
        isFree
        lessons {
          id
          name
          date
          startsAt
          endsAt
          index
          needToFinish
        }
        passedLessonsCount
        lessonsCount
        studentsCount
        name
      }
      ... on StudentGroupType {
        id
        course {
          id
          courseIcon
          name
        }
        statusFinished
        isFree
        lessons {
          id
          name
          date
          startsAt
          endsAt
          index
        }
        # ТЗ 0040 доводка: что и на каком занятии студент получит. Поле есть
        # ТОЛЬКО у студенческого типа — персоналу оно ни к чему.
        skillPlan {
          lessonNumber
          lessonId
          isOver
          skills {
            id
            name
            slug
            category
            iconUrl
            description
            unlockLevel
            courseLevel
            demandVacancies
            demandBand
          }
        }
        passedLessonsCount
        lessonsCount
        studentsCount
        name
      }
      ... on MethodistGroupType {
        id
        course {
          id
          courseIcon
          name
        }
        statusFinished
        isFree
        lessons {
          id
          name
          date
          startsAt
          endsAt
          index
        }
        passedLessonsCount
        lessonsCount
        studentsCount
        name
      }
    }
  }
`;
